import React from 'react';
import gameAssets from '@themed-assets';
import useGetSingleTourneyDefinitionById from '@/src/hooks/data/useGetSingleTourneyDefinitionById';
import useTourneyDetails from '@/src/hooks/utils/useTourneyDetails';
import { formatAmountWithCommas } from '@/src/hooks/utils/utilsFun';

const A23MyTourneyTile = ({ game }) => {
  const singleTourneyId = useGetSingleTourneyDefinitionById(game);
  const tourneyDetails = useTourneyDetails();

  const handleMyTourneyClick = (tourneyId) => {
    tourneyDetails.navigateToTourneyDetails(tourneyId);
  };

  return (
    <div
      className="from-foreground to-surface border-b-surface rounded-300 mr-[10px] h-[91px] w-[219px] flex-1 overflow-hidden border bg-gradient-to-r from-0%"
      onClick={() => handleMyTourneyClick(singleTourneyId?.tourneyId)}
    >
      <div className="bg-foreground text-info text-2xs max-w-[140px] overflow-hidden py-1.5 pr-4 pl-2 text-start font-medium text-ellipsis whitespace-nowrap uppercase [clip-path:polygon(0%_0%,100%_0%,90%_100%,100%_100%,0%_100%)]">
        {singleTourneyId?.tourneyName}
      </div>

      <div className="p-2 pt-0">
        <div className="text-focus flex items-center gap-2 pt-2.5 font-bold">
          <img
            src={gameAssets.crown}
            alt="Tournament prize"
            height={14}
            width={14}
          />

          <div>
            {singleTourneyId?.isFlightTourney ? (
              <div id={singleTourneyId?.tourneyId}>
                <div>
                  {singleTourneyId?.isFlightParentTourney ? (
                    <div>
                      {singleTourneyId?.breakEven
                        ? singleTourneyId?.dynamicPoolPrize > 0
                          ? `₹ ${formatAmountWithCommas(
                              singleTourneyId?.dynamicPoolPrize
                            )}`
                          : ''
                        : singleTourneyId?.prizePool > 0
                          ? `₹ ${formatAmountWithCommas(
                              singleTourneyId?.prizePool
                            )}`
                          : ''}

                      {singleTourneyId?.prizePoolTickets > 0 && (
                        <div className="flex flex-row items-center">
                          {singleTourneyId?.prizePoolTickets > 0 && (
                            <div className="flex flex-row items-center justify-center">
                              {((singleTourneyId?.breakEven &&
                                singleTourneyId?.dynamicPoolPrize > 0) ||
                                singleTourneyId?.prizePool > 0) && (
                                <div className="mx-0.5 text-xs font-bold">
                                  +
                                </div>
                              )}
                              {((singleTourneyId?.breakEven &&
                                singleTourneyId?.dynamicPoolPrize >= 0) ||
                                singleTourneyId?.prizePool >= 0) && (
                                <div className="items-centers flex flex-row items-end justify-center font-bold">
                                  <div className="text-base">
                                    {singleTourneyId?.prizePoolTickets}
                                  </div>
                                  <div
                                    className={`font-bold ${
                                      (singleTourneyId?.breakEven &&
                                        singleTourneyId?.dynamicPoolPrize <=
                                          0) ||
                                      (!singleTourneyId?.breakEven &&
                                        singleTourneyId?.prizePool <= 0)
                                        ? 'text-base'
                                        : 'text-xs'
                                    }ml-1 mb-0.5`}
                                  >
                                    {singleTourneyId?.prizePoolTickets === 1
                                      ? 'Ticket'
                                      : 'Tickets'}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div>
                      {singleTourneyId?.parentTourneyName !== 'NA'
                        ? singleTourneyId?.parentTourneyName
                        : `₹ ${formatAmountWithCommas(
                            singleTourneyId?.prizePool
                          )}`}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div
                id={singleTourneyId.tourneyId}
                className="flex flex-row items-center"
              >
                {/* Prize pool amount */}
                {singleTourneyId?.breakEven
                  ? singleTourneyId?.dynamicPoolPrize > 0
                    ? `₹ ${formatAmountWithCommas(
                        singleTourneyId?.dynamicPoolPrize
                      )}`
                    : ''
                  : singleTourneyId?.prizePool > 0
                    ? `₹ ${formatAmountWithCommas(singleTourneyId?.prizePool)}`
                    : ''}

                {/* Tickets display */}
                {singleTourneyId?.prizePoolTickets > 0 && (
                  <div className="flex flex-row items-center justify-center">
                    {((singleTourneyId?.breakEven &&
                      singleTourneyId?.dynamicPoolPrize > 0) ||
                      singleTourneyId?.prizePool > 0) && (
                      <span className="mx-0.5 text-xs font-bold">+</span>
                    )}
                    {((singleTourneyId?.breakEven &&
                      singleTourneyId?.dynamicPoolPrize >= 0) ||
                      singleTourneyId?.prizePool >= 0) && (
                      <div className="items-centers flex flex-row items-end justify-center font-bold">
                        <div className="text-base">
                          {singleTourneyId?.prizePoolTickets}
                        </div>
                        <div
                          className={`${
                            (singleTourneyId?.breakEven &&
                              singleTourneyId?.dynamicPoolPrize <= 0) ||
                            (!singleTourneyId?.breakEven &&
                              singleTourneyId?.prizePool <= 0)
                              ? 'text-base'
                              : 'mb-0.5 text-xs'
                          } ml-1`}
                        >
                          {singleTourneyId?.prizePoolTickets === 1
                            ? 'Ticket'
                            : 'Tickets'}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="text-secondary flex items-center justify-between pt-1.5">
          <div className="flex items-center gap-1">
            <img
              src={gameAssets.userIcon}
              alt="Number of players"
              height={12}
              width={12}
            />
            <div className="ml-2 text-xs font-medium">
              {singleTourneyId?.registeredPlayerCount} Entries
            </div>
          </div>

          <div className="flex items-center gap-1">
            <div className="text-primary pr-1 text-xs font-normal">
              {singleTourneyId?.tourneyStatus === 'LIVE' ? (
                <div className="text-success text-xs font-medium">Running</div>
              ) : singleTourneyId?.tourneyStatus === 'REGISTRATION_STARTED' ? (
                <div className="text-success text-xs font-medium">
                  Registered
                </div>
              ) : (
                <></>
              )}
            </div>
            <img src={gameAssets.rightArrow} alt="View tournament details" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default A23MyTourneyTile;
